/**
 * Roles expected to run the activity agent. Every agent-facing route gates on
 * this list (enrol, event ingest, shift, latest release), and
 * GET /v1/admin/stats/agent-enrolment reports signed-up accounts in these roles
 * that have no active device. One list, so the gate and the report cannot
 * disagree about who should have the agent (ClickUp 86d4akbgx).
 *
 * Only add a role here if every signed-up account in it should run the agent,
 * because adding it also puts the role in the report. A role that may run the
 * agent but is not expected to goes on the gate alone, as an extra argument:
 * `requireRole(...AGENT_REQUIRED_ROLES, 'admin')`, as latest-release does.
 */
export const AGENT_REQUIRED_ROLES = ['doer', 'dsl', 'support_staff'];
//# sourceMappingURL=agent-devices.js.map